<template>
    <div id="authorizationVanta">
        <div class="d-flex justify-center">
            <div class="authorization">
                <registration-form
                    @changeForm="changeForm()"
                    v-if="form === 'registration'"
                />
                <login-form
                    @changeForm="changeForm()"
                    @resetPassword="changeForm(true)"
                    v-if="form === 'login'"
                />
                <reset-password-email-form
                    @changeForm="
                        () => {
                            form = 'login'
                        }
                    "
                    v-if="form === 'reset'"
                />
            </div>
        </div>
    </div>
</template>
<script>
import LoginForm from '@/components/forms/LoginForm.vue'
import RegistrationForm from '@/components/forms/RegistrationForm.vue'
import ResetPasswordEmailForm from '@/components/forms/ResetPasswordEmailForm.vue'
import * as THREE from 'three'
import NET from 'vanta/dist/vanta.net.min'

export default {
    name: 'AuthorizationPage',
    components: {
        LoginForm,
        RegistrationForm,
        ResetPasswordEmailForm
    },
    data() {
        return {
            form: 'login'
        }
    },
    mounted() {
        this.vantaEffect = NET({
            el: '#authorizationVanta',
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            scale: 1.0,
            scaleMobile: 1.0,
            color: 0x0f3384,
            backgroundColor: 0x01174d,
            THREE
        })
    },
    methods: {
        changeForm(isResetPassword = false) {
            if (isResetPassword) {
                this.form = 'reset'
                return
            }
            if (this.form == 'login') {
                this.form = 'registration'
                return
            }
            if (this.form == 'registration') this.form = 'login'
            return
        }
    }
}
</script>

